// const isLowerEnvironment = window.jllConfig.env !== "Production";
// process.env.NODE_ENV !== "production";

const HOME = {
  label: "Home",
  url: "/",
};

const GOALS = {
  label: "Goals",
  url: "/goals",
};

const PLANS = {
  label: "Plans",
  url: "/plans",
};

const PRE_TRANSCTION = {
  label: "Pre-transactions",
  url: "/pre-transaction",
};

const TRANSACTION = {
  label: "Transactions",
  url: "/transaction",
};

const PROPERTY = {
  label: "Properties",
  url: "/property",
};

const LEASE = {
  label: "Leases",
  url: "/lease",
};

const LEASE_EVENT = {
  label: "Lease Events",
  url: "/lease-event",
};

const RESOURCES = {
  label: "Resources",
  url: "/resources",
};

const HEADER_LINKS = [
  HOME,
  PRE_TRANSCTION,
  TRANSACTION,
  PROPERTY,
  LEASE,
  LEASE_EVENT,
];

const SUPER_ADMIN_LINKS = [
  {
    pageUrl: "/admin/manual-upload",
    imageUrl: "Upload.svg",
    name: "Non-OVLA upload",
  },
  {
    pageUrl: "/admin/transaction-upload",
    imageUrl: "Upload.svg",
    name: "Transaction upload",
  },
  {
    pageUrl: "/admin/clients",
    imageUrl: "ic_list.svg",
    name: "Client list",
  },
  {
    imageUrl: "user_list.svg",
    name: "Users",
    items: [
      {
        pageUrl: "/admin/users/user-list",
        imageUrl: "ic_list.svg",
        name: "User list",
      },
      {
        pageUrl: "/admin/users/usage-insights",
        imageUrl: "ic_template_mgmt.svg",
        name: "Usage insights",
      },
    ].filter(Boolean),
  },

  // temporarily removing since feature isn't finished
  // {
  //   imageUrl: "user_insights.svg",
  //   name: "Insights",
  //   items: [
  //     {
  //       pageUrl: "/admin/insights/user",
  //       imageUrl: "user_insights.svg",
  //       name: "User Insights",
  //     },
  //     {
  //       pageUrl: "/admin/insights/developer",
  //       imageUrl: "developer_insights.svg",
  //       name: "Developer Insights",
  //     },
  //   ],
  // },
  {
    imageUrl: "ic_settings_.svg",
    name: "Management",
    items: [
      {
        pageUrl: "/admin/management/template",
        imageUrl: "ic_template_mgmt.svg",
        name: "Template management",
      },
      // {
      //   pageUrl: "/admin/management/task",
      //   imageUrl: "ic_task_mgmt.svg",
      //   name: "Task management",
      // },
      // {
      //   pageUrl: "/admin/management/transaction",
      //   imageUrl: "settings_t.svg",
      //   name: "Transaction management",
      // },
      // {
      //   pageUrl: "/admin/management/transaction-types",
      //   imageUrl: "settings_t.svg",
      //   name: "Transaction type management",
      // },
      // {
      //   pageUrl: "/admin/management/pre-transaction",
      //   imageUrl: "settings_p.svg",
      //   name: "Pre-transaction management",
      // },
      // {
      //   pageUrl: "/admin/management/user-defined-fields",
      //   imageUrl: "client_list.svg",
      //   name: "Account defined fields",
      // },
    ].filter(Boolean),
  },
  {
    imageUrl: "ic_data_settings.svg",
    name: "Data management",
    items: [
      {
        pageUrl: "/admin/data-management/load-schedule",
        imageUrl: "ic_schedule.svg",
        name: "Data load schedule",
      },
      {
        pageUrl: "/admin/data-management/governance",
        imageUrl: "ic_data_governance.svg",
        name: "Data governance",
      },
      {
        pageUrl: "/admin/data-management/cache",
        imageUrl: "client_list.svg",
        name: "Cache management",
      },
    ],
  },
  // temporarily removing since feature isn't finished
  // {
  //   imageUrl: "feed.svg",
  //   name: "Summary Dashboards",
  //   items: [
  //     {
  //       pageUrl: "/admin/dashboard/transaction-review",
  //       imageUrl: "transaction_summary.svg",
  //       name: "Transaction Results Overview",
  //     },
  //     {
  //       pageUrl: "/admin/dashboard/flex-review",
  //       imageUrl: "transaction_summary.svg",
  //       name: "Flex Transaction Results Overview",
  //     },
  //   ],
  // },
].filter(Boolean);

const SUPER_ADMIN_MENU = {
  imageUrl: "ic_super_account.svg",
  name: "Super adminstration",
  items: SUPER_ADMIN_LINKS,
};

const USER_PROFILE = {
  pageUrl:
  "/users/user-setting",
  imageUrl: "user-guide.svg",
  name: "User profile",
};

const ADMIN_MENU = {
  pageUrl:
  "/admin/account-admin",
  imageUrl: "user-guide.svg",
  name: "Administration settings"
};

const USER_GUIDE = {
  pageUrl:
    "https://jll2.sharepoint.com/:w:/r/teams/GlobalTMTeamSite/TM%20Resources%20Links/User%20Guide/TM%20Tracker%20User%20Guide.docx?d=w46d8564ad08b465a8dbf049038f34ecf&csf=1&web=1&e=i2lJD2",
  imageUrl: "user-guide.svg",
  name: "User guide",
  isAbsolute: true,
};

const CONTACT_SUPPORT = {
  pageUrl:
    "https://jll.service-now.com/sp?id=sc_cat_item&sys_id=bc5d72051bbcf8903a13fee3cc4bcb93&sysparm_category=e89e97981bd47490831d99b51a4bcb31",
  imageUrl: "support.svg",
  name: "Contact support",
  isAbsolute: true,
};

const CHANGE_HISTORY = {
  pageUrl:
    "https://jll2.sharepoint.com/:w:/t/TMProducts-BIteam/EeEpYoQF9etNmcDV_wChqdgBojKMS6AkbRxqAEL3pyiW9w?e=Er5jCD",
  imageUrl: "ChangeHistory.svg",
  name: "Version history",
  isAbsolute: true,
};

const LOGOUT = {
  pageUrl: "/logout",
  imageUrl: "Logout.svg",
  name: "Logout",
};

const MENU_LINKS = [USER_GUIDE, CONTACT_SUPPORT, CHANGE_HISTORY, LOGOUT];

export { HEADER_LINKS , ADMIN_MENU, MENU_LINKS , SUPER_ADMIN_MENU, USER_PROFILE };
